// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3jBmt","clinicsSelect":"styles_clinicsSelect__3jjxr"};